import { useEffect, useState } from 'preact/hooks';

export default function FilterBoxList({
	items,
	isInsidePopup = false,
	showFewer = false,
	filters,
	setFilters,
	filterKey
}) {
	const [showRestOfItems, setShowRestOfItems] = useState(false);

	const onlyTopLevelItems = items?.filter(
		i => i.parentId === null || typeof i.parentId === 'undefined'
	);

	let firstItems = onlyTopLevelItems;
	let restOfItems = null;

	if (showFewer) {
		firstItems = onlyTopLevelItems?.slice(0, 9);
		restOfItems = onlyTopLevelItems?.slice(9);
	}

	return (
		<>
			<ul
				class={`flex flex-col gap-y-2 text-sm lg:gap-y-1 lg:text-sm ${
					isInsidePopup ? 'pb-16' : ''
				}`}
			>
				{firstItems?.map(item => (
					<ListItem
						item={item}
						filters={filters}
						setFilters={setFilters}
						filterKey={filterKey}
					/>
				))}
				{restOfItems &&
					showRestOfItems &&
					restOfItems.map(item => (
						<ListItem
							item={item}
							filters={filters}
							setFilters={setFilters}
							filterKey={filterKey}
						/>
					))}
			</ul>
			{restOfItems?.length >= 1 && (
				<button
					class="font-semibold text-blue font-sm mt-2"
					onClick={() => setShowRestOfItems(!showRestOfItems)}
				>
					{showRestOfItems ? 'Vis færre' : 'Vis alle'}
				</button>
			)}
		</>
	);
}

function ListItem({ item, filters, setFilters, filterKey }) {
	const [isChildrenOpen, setIsChildrenOpen] = useState(false);

	function existsInFilters(termItem) {
		return filters[filterKey].some(f => f.slug === termItem.slug);
	}

	function handleSetFilter(termItem) {
		// If state object key's array contains term slug, remove it
		// Also removes children from state when de-checking parent
		if (existsInFilters(termItem)) {
			const newTermObjects = filters[filterKey].filter(
				term =>
					term.slug !== termItem.slug &&
					!termItem?.children?.nodes?.some(
						child => child.slug === term.slug
					)
			);
			setFilters(prev => ({
				...prev,
				[filterKey]: newTermObjects
			}));
		} else {
			// Else add it
			setFilters(prev => ({
				...prev,
				[filterKey]: [
					...filters[filterKey],
					{ slug: termItem.slug, name: termItem.name }
				]
			}));
		}
	}

	const [isChecked, setIsChecked] = useState(false);

	useEffect(() => {
		setIsChecked(existsInFilters(item));
		setIsChildrenOpen(existsInFilters(item));
	}, [filters]);

	return (
		<li key={item.slug}>
			<label class="app-checkbox-label inline-flex gap-x-2">
				<input
					type="checkbox"
					id={item.slug}
					class="app-checkbox cursor-pointer appearance-none bg-white w-5 h-5 border border-dark rounded bg-center bg-no-repeat flex-shrink-0"
					onClick={e => {
						e.stopPropagation();
						handleSetFilter(item);
					}}
					checked={isChecked}
				></input>
				<span
					class={`${
						item.color
							? `py-0.5 px-1.5 -mt-0.5 ${item.color}`
							: 'mb-1'
					}`}
				>
					{item.name}
					{item.children?.nodes?.length >= 1 && (
						<i
							class={`far fa-chevron-down ml-1 text-xs inline-block transform ${
								isChildrenOpen ? 'rotate-180' : ''
							}`}
						></i>
					)}
				</span>
			</label>

			{item.children?.nodes?.length >= 1 && (
				<ul
					class={`pl-7 my-1 ${
						isChildrenOpen ? 'flex flex-col gap-y-1' : 'hidden'
					}`}
				>
					{item.children.nodes.map(child => {
						const [isChildChecked, setIsChildChecked] = useState(
							false
						);
						useEffect(() => {
							setIsChildChecked(existsInFilters(child));
						}, [filters]);
						return (
							<li key={child.slug}>
								<label class="app-checkbox-label inline-flex gap-x-2">
									<input
										type="checkbox"
										class="app-checkbox appearance-none bg-white w-5 h-5 border border-dark rounded bg-center bg-no-repeat flex-shrink-0"
										onClick={e => {
											e.stopPropagation();
											handleSetFilter(child);
										}}
										checked={isChildChecked}
									></input>
									<span class="mb-1">{child.name}</span>
								</label>
							</li>
						);
					})}
				</ul>
			)}
		</li>
	);
}
